import React from 'react'

export const IconVideoCamera = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      id="video2"
      viewBox="151.9 302.2 291.6 237.5"
      fill="currentColor"
      {...props}
    >
      <path d="M438.9 395.2c-2.8-1.6-6.3-1.5-9 .2l-48 29.6v-18.8c0-19.3-15.7-35.1-35.1-35.1 3.3-5.5 5.2-11.9 5.2-18.7 0-20.2-16.4-36.6-36.6-36.6-20.2 0-36.6 16.4-36.6 36.6 0 6.9 1.9 13.3 5.2 18.7h-23.8c5.3-7.2 8.4-16 8.4-25.5 0-23.9-19.5-43.4-43.4-43.4s-43.4 19.5-43.4 43.4c0 9.6 3.1 18.4 8.4 25.5H187c-19.4 0-35.1 15.7-35.1 35.1v98.4c0 19.3 15.8 35.1 35.1 35.1h159.8c19.4 0 35.1-15.7 35.1-35.1v-18.8l48 29.7c1.4.9 3.1 1.3 4.7 1.3 1.5 0 3-.4 4.3-1.1 2.8-1.6 4.6-4.6 4.6-7.8V403c-.1-3.3-1.8-6.3-4.6-7.8zm-142.3-42.8c0-10.3 8.4-18.7 18.7-18.7 10.3 0 18.7 8.4 18.7 18.7 0 10.3-8.4 18.7-18.7 18.7-10.3 0-18.7-8.4-18.7-18.7zm-97-6.8c0-14.1 11.5-25.5 25.5-25.5s25.5 11.5 25.5 25.5c0 14.1-11.5 25.5-25.5 25.5s-25.5-11.4-25.5-25.5zm164.4 159c0 9.5-7.7 17.2-17.2 17.2H186.9c-9.5 0-17.2-7.7-17.2-17.2v-98.4c0-9.5 7.7-17.2 17.2-17.2h159.8c9.5 0 17.2 7.7 17.2 17.2l.1 98.4zm61.6-12.7l-43.7-27V446l43.7-27v72.9z"></path>
      <path d="M199.5 420.8h136"></path>
    </svg>
  )
}
